export const CONDITION_MESSAGE_DELAY = 3000;
